export enum MainLogoPositionEnum {
  HEADER = 'headed-bar',
  NAVIGATION_MENU = 'menu-bar-top'
}
